import Axios from './axios'
import { HttpResponse } from '@/@types'
/**
 * @interface loginParams -登录参数
 * @property {string} loginName -用户名
 * @property {string} password -用户密码
 */
interface LoginParams {
  loginName: string
  password: string
}
// 封装User类型的接口方法
export class UserService {

  // eslint-disable-next-line require-await
  static async resgister(params: LoginParams): Promise<HttpResponse> {
    return Axios('/signin/signin_submit/', {
      method: 'post',
      responseType: 'json',
      params: {
        ...params
      },
    })
  }
  // eslint-disable-next-line require-await
  static async login(data:any) {
    return Axios('/signin/signin_and_register/', {
      method: 'post',
      data,
    })
  }
  // eslint-disable-next-line require-await
  static async loginOut() {
    return Axios('/logout/', {
      method: 'get'
    })
  }
  // eslint-disable-next-line require-await
  static async findPassword(data:any) {
    return Axios('/signin/find_password/', {
      method: 'post',
      data,
    })
  }
  // eslint-disable-next-line require-await
  static async bindMobile(data:any) {
    return Axios('/signin/bind_mobile/', {
      method: 'post',
      data,
    })
  }
  // eslint-disable-next-line require-await
  static async modifyPassword(data:any) {
    return Axios('/user/modify_password/', {
      method: 'post',
      data,
    })
  }
  // eslint-disable-next-line require-await
  static async wechatScan(data:any) {
    return Axios('/wechat/scan/', {
      method: 'get',
      params: {
        ...data
      },
    })
  }
  // eslint-disable-next-line require-await
  static async wechatCheck(data:any) {
    return Axios('/wechat/scan/check/', {
      method: 'get',
      params: {
        ...data
      },
    })
  }
  // eslint-disable-next-line require-await
  static async getBindMobileCode(data:any) {
    return Axios('/signin/send_bind_mobile_code/', {
      method: 'get',
      params: {
        ...data
      },
    })
  }
  
  // eslint-disable-next-line require-await
  static async getLoginCode(data:any) {
    return Axios('/signin/send_verify_code/', {
      method: 'get',
      params: {
        ...data
      },
    })
  }
  // eslint-disable-next-line require-await
  static async getRegCode(data:any) {
    return Axios('/signin/send_reg_verify_code/', {
      method: 'get',
      params: {
        ...data
      },
    })
  }
  // eslint-disable-next-line require-await
  static async getPasswordCode(data:any) {
    return Axios('/signin/send_password_verify_code/', {
      method: 'get',
      params: {
        ...data
      },
    })
  }
  // eslint-disable-next-line require-await
  static async userInfo(data: any) {
    return Axios('/user/info/', {
      method: 'get',
      data,
    })
  }
  // 用户信息
  // eslint-disable-next-line require-await
  static async sessionInfo(data: any) {
    return Axios('/common/session_info/', {
      method: 'get',
      data,
    })
  }
  // eslint-disable-next-line require-await
  static async getChangeMobileCode(data:any) {
    return Axios('/signin/send_change_mobile_code/', {
      method: 'get',
      params: {
        ...data
      },
    })
  }
  // eslint-disable-next-line require-await
  static async changeMobile(data:any) {
    return Axios('/signin/change_mobile/', {
      method: 'post',
      data,
    })
  }
  // eslint-disable-next-line require-await
  static async vipCheck(data:any) {
    return Axios('/user/vip/check/', {
      method: 'post',
      data,
    })
  }
  
}
